import {breakpoint, assets_path} from '@/_constant/variables';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  os: '',
  isPc: true,
  isTop: false,
  isShowNav: false,
  isShowModal: false,
  containerClass: '',
  /*
  isShowLoading: true,
  isShowCover: false,
  isShowHeader: true,
  isHeaderTransition: false,
  currentFrameID: null,
  */
  urls: {
    top: '/',
    about: '/about/',
    recruit: '/recruit/',
  }
};

const mutations = {
  setPc(state, val) {
    state.isPc = val;
  },
  setTop(state, val) {
    state.isTop = val;
  },
  setContainerClass(state, val) {
    state.containerClass = val;
  },
  setShowNav(state, val) {
    state.isShowNav = val;
  },
  setShowModal(state, val) {
    state.isShowModal = val;
  },
  /*
  setOS(state) {
    const ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf("mac os x") !== -1) {
      state.os = 'mac';
    }
  },
  setShowLoading(state, isShow) {
    state.isShowLoading = isShow;
  },
  setShowCover(state, isShow) {
    state.isShowCover = isShow;
  },
  setShowHeader(state, isShow) {
    state.isShowHeader = isShow;
  },
  setHeaderTransition(state, isShow) {
    state.isHeaderTransition = isShow;
  },
  setCurrentFrameID(state, frameID) {
    state.currentFrameID = frameID;
  }
  */
};

const getters = {
  isPc: (state) => {
    return state.isPc;
  },
  isTop: (state) => {
    return state.isTop;
  },
  getContainerClass(state) {
    return state.containerClass;
  },
  isShowNav: (state) => {
    return state.isShowNav;
  },
  isShowModal: (state) => {
    return state.isShowModal;
  },
  /*
  getOS: (state) => {
    return state.os;
  },
  isShowLoading: (state) => {
    return state.isShowLoading;
  },
  isShowCover: (state) => {
    return state.isShowCover;
  },
  isShowHeader: (state) => {
    return state.isShowHeader;
  },
  isHeaderTransition: (state) => {
    return state.isHeaderTransition;
  },
  currentFrameID(state) {
    return state.currentFrameID;
  },
  getUrls: (state) => {
    return state.urls;
  }
  */
};

export default new Vuex.Store({
  state,
  getters,
  mutations
});